import React from "react";

import { Trans, withTranslation } from "react-i18next";

import {
  Callout,
  Icon,
  Card,
  Tabs,
  Tab,
  TabsExpander,
  Tooltip,
  Pre,
} from "@blueprintjs/core";

import PasswordChanger from "./PasswordChanger";
import UserList from "./UserList";
import FavoriteSelector from "./UserFavoritesEditor";
import { getLoggedUser } from "../auth/Signin";
import AlertManager from "./AlertManager";
import ParkingStructure from "./ParkingStructure/ParkingStructure";
import { LogoSelector } from "./LogoSelector";
import Maintenance from "./Maintenance/Maintenance";
import InstallationSettings from "./InstallationSettings";
import CustomSupEditor from "./CustomSupEditor";
import CustomActivityEditor from "./CustomActivityEditor";
import EventFilteringEditor from "./EventFilteringEditor";
import ApiKeyList from "./ApiKeyList";
import Title from "../Structure/logo";
import ExportScriptEditor from "./ExportScriptEditor";
import GroupTable from "./ParkingStructure/Groups";
import FileSync from "./Maintenance/FileSync";
import DetectionClassificationSettings from "./DetectionClassification/DetectionClassification";
import { authenticatedGetFetch } from "../../utils/AuthenticatedFetch";

const admin_warning = (
  <Trans>
    these settings are sensible and can only be changed by the installator
  </Trans>
);

class Settings extends React.Component {
  constructor() {
    super();
    this.state = { version: undefined };
  }

  componentDidMount() {
    if (localStorage.getItem("perm_superadmin") === "true")
      authenticatedGetFetch("/version", (version) =>
        this.setState({ version: version })
      );
  }

  render() {
    return (
      <div className="component-body">
        <Title icon="cog" text={<Trans>settings</Trans>} />

        <Tabs
          id="settingmenu"
          fill={true}
          vertical={true}
          renderActiveTabPanelOnly={true}
          defaultSelectedTabId="ma"
        >
          <Tab
            id="ma"
            title={<Trans>my account</Trans>}
            icon="user"
            panel={
              <Callout title={<Trans>my account</Trans>} icon="user">
                <Callout title={<Trans>login credentials</Trans>}>
                  <Trans>your login</Trans> : <b>{getLoggedUser()}</b>
                  <PasswordChanger />
                </Callout>
                <Callout title={<Trans>permissions</Trans>}>
                  <Callout intent="primary">
                    <Trans>
                      for any change of your permissions please contact an
                      administrator
                    </Trans>
                  </Callout>
                  <Card>
                    {localStorage.getItem("perm_financial_display") ===
                      "true" && (
                      <p>
                        <span>
                          <Icon icon="document" />{" "}
                          <Trans>access to financial report</Trans>
                        </span>{" "}
                        :{" "}
                        {localStorage.getItem("perm_financial") === "true" ? (
                          <Icon icon="endorsed" intent="success" />
                        ) : (
                          <Icon icon="disable" intent="danger" />
                        )}
                      </p>
                    )}
                    {localStorage.getItem("perm_activity_display") ===
                      "true" && (
                      <p>
                        <span>
                          <Icon icon="timeline-line-chart" />{" "}
                          <Trans>access to activity report</Trans>
                        </span>{" "}
                        :{" "}
                        {localStorage.getItem("perm_activity") === "true" ? (
                          <Icon icon="endorsed" intent="success" />
                        ) : (
                          <Icon icon="disable" intent="danger" />
                        )}
                      </p>
                    )}
                    {localStorage.getItem("perm_custom_report_display") ===
                      "true" && (
                      <p>
                        <span>
                          <Icon icon="timeline-bar-chart" />{" "}
                          <Trans>access to custom report report</Trans>
                        </span>{" "}
                        :{" "}
                        {localStorage.getItem("perm_custom_report") ===
                        "true" ? (
                          <Icon icon="endorsed" intent="success" />
                        ) : (
                          <Icon icon="disable" intent="danger" />
                        )}
                      </p>
                    )}
                    {localStorage.getItem("perm_SPV_display") === "true" && (
                      <p>
                        <span>
                          <Icon icon="drive-time" />{" "}
                          <Trans>access to the real time supervision</Trans>
                        </span>{" "}
                        :{" "}
                        {localStorage.getItem("perm_SPV") === "true" ? (
                          <Icon icon="endorsed" intent="success" />
                        ) : (
                          <Icon icon="disable" intent="danger" />
                        )}
                      </p>
                    )}
                    {localStorage.getItem("perm_bonification") === "true" && (
                      <p>
                        <span>
                          <Icon icon="tag" /> <Trans>access to Bonitick</Trans>
                        </span>{" "}
                        :{" "}
                        {localStorage.getItem("perm_bonification") ===
                        "true" ? (
                          <Icon icon="endorsed" intent="success" />
                        ) : (
                          <Icon icon="disable" intent="danger" />
                        )}
                      </p>
                    )}
                    {localStorage.getItem("perm_extern_access_ctrl") ===
                      "true" && (
                      <p>
                        <span>
                          <Icon icon="changes" />{" "}
                          <Trans>access to external access control</Trans>
                        </span>{" "}
                        :{" "}
                        {localStorage.getItem("perm_extern_access_ctrl") ===
                        "true" ? (
                          <Icon icon="endorsed" intent="success" />
                        ) : (
                          <Icon icon="disable" intent="danger" />
                        )}
                      </p>
                    )}
                    <p>
                      <span>
                        <Icon icon="crown" />{" "}
                        <Trans>administration permissions</Trans>
                      </span>{" "}
                      :{" "}
                      {localStorage.getItem("perm_admin") === "true" ? (
                        <Icon icon="endorsed" intent="success" />
                      ) : (
                        <Icon icon="disable" intent="danger" />
                      )}
                    </p>
                  </Card>
                </Callout>
              </Callout>
            }
          />

          {localStorage.getItem("perm_home_customisation") === "true" && (
            <Tab
              id="hp"
              title={<Trans>my home page</Trans>}
              icon="home"
              panel={<FavoriteSelector />}
            />
          )}

          {localStorage.getItem("perm_admin") === "true" && (
            <Tab
              id="um"
              title={<Trans>user management</Trans>}
              icon="team"
              panel={<UserList />}
            />
          )}

          {localStorage.getItem("perm_admin") === "true" && (
            <Tab
              id="cl"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>Logo client</Trans>
                </Tooltip>
              }
              icon="media"
              panel={<LogoSelector />}
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="ps"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>parking structure</Trans>
                </Tooltip>
              }
              icon="th"
              panel={<ParkingStructure />}
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="se"
              title={<Tooltip content={admin_warning}>Supervision</Tooltip>}
              icon="drive-time"
              panel={
                <span>
                  <CustomSupEditor /> <br /> <GroupTable />
                </span>
              }
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="ar"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>activity report</Trans>
                </Tooltip>
              }
              icon="timeline-line-chart"
              panel={<CustomActivityEditor />}
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="mt"
              title={<Tooltip content={admin_warning}>Maintenance</Tooltip>}
              icon="tree"
              panel={<Maintenance />}
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="ef"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>event filtering</Trans>
                </Tooltip>
              }
              icon="filter-list"
              panel={<EventFilteringEditor />}
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="ak"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>API and exports</Trans>
                </Tooltip>
              }
              icon="code"
              panel={
                <span>
                  <ApiKeyList />
                  <br />
                  <ExportScriptEditor />
                </span>
              }
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="dc"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>ALPR</Trans>
                </Tooltip>
              }
              icon="widget-button"
              panel={<DetectionClassificationSettings />}
            />
          )}

          {localStorage.getItem("perm_admin") === "true" &&
            localStorage.getItem("perm_SPV_display") === "true" && (
              <Tab
                id="am"
                title={
                  <Tooltip content={admin_warning}>
                    <Trans>alert management</Trans>
                  </Tooltip>
                }
                icon="notifications"
                panel={<AlertManager />}
              />
            )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="fs"
              title={
                <Tooltip content={admin_warning}>
                  <Trans>file sync</Trans>
                </Tooltip>
              }
              icon="data-sync"
              panel={<FileSync />}
            />
          )}

          {localStorage.getItem("perm_superadmin") === "true" && (
            <Tab
              id="is"
              title={<Tooltip content={admin_warning}>Options</Tooltip>}
              icon="segmented-control"
              panel={<InstallationSettings />}
            />
          )}

          <TabsExpander />
          <img
            style={{ maxHeight: 100, maxWidth: 300 }}
            className="noselect"
            src="/ow/view/pictures/hitachi.png"
            alt=""
          />
          {this.state?.version?.version && (
            <Pre>{this.state?.version?.version}</Pre>
          )}
        </Tabs>
      </div>
    );
  }
}

export default withTranslation()(Settings);
